import Rule from './Rule'

export default class Rules {
  public rules: Array<Rule>;

  constructor(data: any) {
    this.rules = new Array<Rule>();
  }

  public dbFormat(): any {
    let data = new Map<String, number>();
    this.rules.forEach(rule => {
      if (rule.config?.minValue === undefined || rule.config?.maxValue === undefined) {
        return;
      }

      if (rule.config?.singleValue) {
        if (rule.value !== undefined && rule.value !== rule.config.minValue && rule.value !== rule.config.maxValue) data[rule.type] = rule.value;
      } else {
        if (rule.value[0] !== undefined && rule.value[0] > rule.config.minValue) data[`low${rule.type}`] = rule.value[0];
        if (rule.value[1] !== undefined && rule.value[1] < rule.config.maxValue) data[`high${rule.type}`] = rule.value[1];
      }
    });
    return data;
  }
}
